import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './components/Homepage';
import EngineerRegistration from './components/EngineerRegistration';
import SocietyRegistration from './components/SocietyRegistration';
import EngineerLotteryRegistration from './components/EngineerLotteryRegistration';
import SocietyLotteryRegistration from './components/SocietyLotteryRegistration';
import OpenApplication from './components/OpenApplication';
import DocumentList from './components/DocumentList';
import SocietyDocumentList from './components/SocietyDocumentList';
import Login from './components/login';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Engineer Components
import EngineerDashboard from './components/Engineer/EngineerDashboard';
import EngineerAllUsers from './components/Engineer/EngineerAllUsers';
import EngineerWorkNames from './components/Engineer/EngineerWorkNames';
import EngineerAddWork from './components/Engineer/EngineerAddWork';
import EngineerWorkNamesMenu from './components/Engineer/EngineerWorkNamesMenu';
import EngineerWorkInfo from './components/Engineer/EngineerWorkInfo';
import EngineerApprovedWorks from './components/Engineer/EngineerApprovedWorks';
import EngineerLotteryCompletedWorkList from './components/Engineer/EngineerLotteryCompletedWorkList';
import EngineerAbove10LCWorks from './components/Engineer/EngineerAbove10LCWorks';
import EngineerAddBulkWork from './components/Engineer/EngineerAddBulkWork';
import EngineerWorkReportsMenu from './components/Engineer/EngineerWorkReportsMenu';
import EngineerSumeTransferWorkList from './components/Engineer/EngineerSumeTransferWorkList';
import EngineerSocietyTransferWorkList from './components/Engineer/EngineerSocietyTransferWorkList';
import EngineerOtherTransferWorks from './components/Engineer/EngineerOtherTransferWorks';
import EngineerTenderWorksMenu from './components/Engineer/EngineerTenderWorksMenu';
import EngineerTenderWorkList from './components/Engineer/EngineerTenderWorkList';
import EngineerEngineerList from './components/Engineer/EngineerEngineerList';
import EngineerEngineerDetails from './components/Engineer/EngineerEngineerDetails';
import EngineerOldEngineerList from './components/Engineer/EngineerOldEngineerList';
import EngineerWorkDetails from './components/Engineer/EngineerWorkDetails';
import EngineerSocietyList from './components/Engineer/EngineerSocietyList';
import EngineerSocietyDetails from './components/Engineer/EngineerSocietyDetails';
import EngineerSocietyMenu from './components/Engineer/EngineerSocietyMenu';
import EngineerDDRCertificate from './components/Engineer/EngineerDDRCertificate';
import EngineerGenerateCertificate from './components/Engineer/EngineerGenerateCertificate';
import EngineerExtendLimit from './components/Engineer/EngineerExtendLimit';
import EngineerExtendLimitEdit from './components/Engineer/EngineerExtendLimitEdit';
import EngineerWorkPassbookMenu from './components/Engineer/EngineerWorkPassbookMenu';
import EngineerSubheWorkList from './components/Engineer/EngineerSubheWorkList';
import EngineerSocietyWorkList from './components/Engineer/EngineerSocietyWorkList';
import EngineerSocietyWorkDetail from './components/Engineer/EngineerSocietyWorkDetail';
import EngineerSubheWorkDetail from './components/Engineer/EngineerSubheWorkDetail';
import EngineerForm65Menu from './components/Engineer/EngineerForm65Menu';
import EngineerSubheForm65 from './components/Engineer/EngineerSubheForm65';
import EngineerSocietyForm65 from './components/Engineer/EngineerSocietyForm65';
import EngineerReportsMenu from './components/Engineer/EngineerReportsMenu';
import EngineerSubheCertificates from './components/Engineer/EngineerSubheCertificates';
import EngineerSubheInterestedWorksMenu from './components/Engineer/EngineerSubheInterestedWorksMenu';
import EngineerSubheInterestedWorksList from './components/Engineer/EngineerSubheInterestedWorksList';
import EngineerSocietyInterestedWorksMenu from './components/Engineer/EngineerSocietyInterestedWorksMenu';
import EngineerSocietyInterestedWorksList from './components/Engineer/EngineerSocietyInterestedWorksList';
import EngineerSocietyLotteryList from './components/Engineer/EngineerSocietyLotteryList';
import EngineerSocietyLotteryListReport from './components/Engineer/EngineerSocietyLotteryListReport';
import EngineerSocietyInterestedWorksByDate from './components/Engineer/EngineerSocietyInterestedWorksByDate';
import EngineerSocietyInterestedWorksDetail from './components/Engineer/EngineerSocietyInterestedWorksDetail';
import EngineerLotteryReportsMenu from './components/Engineer/EngineerLotteryReportsMenu';
import EngineerSubheLotteryList from './components/Engineer/EngineerSubheLotteryList';
import EngineerSubheInterestedWorksByDate from './components/Engineer/EngineerSubheInterestedWorksByDate';
import EngineerSubheInterestedWorksDetail from './components/Engineer/EngineerSubheInterestedWorksDetail';
import EngineerSubheGenerateLottery from './components/Engineer/EngineerSubheGenerateLottery';
import EngineerDistrictLotteryListReport from './components/Engineer/EngineerDistrictLotteryListReport';
import EngineerEngineerLotteryList from './components/Engineer/EngineerEngineerLotteryList';
import EngineerInterGovernanceMenu from './components/Engineer/EngineerInterGovernanceMenu';
import EngineerInterGovernanceWorksList from './components/Engineer/EngineerInterGovernanceWorksList';
import EngineerInterGovernanceWorksByDate from './components/Engineer/EngineerInterGovernanceWorksByDate';
import EngineerTotalWorkDistributionMenu from './components/Engineer/EngineerTotalWorkDistributionMenu';
import EngineerSubWorksDistributionList from './components/Engineer/EngineerSubWorksDistributionList';
import EngineerSocietyWorksDistributionList from './components/Engineer/EngineerSocietyWorksDistributionList';
import EngineerLotteryWorkDistributionMenu from './components/Engineer/EngineerLotteryWorkDistributionMenu';
import EngineerLotterySubWorksDistributionList from './components/Engineer/EngineerLotterySubWorksDistributionList';
import EngineerLotterySocietyWorksDistributionList from './components/Engineer/EngineerLotterySocietyWorksDistributionList';
import EngineerApprovedRecordsMenu from './components/Engineer/EngineerApprovedRecordsMenu';
import EngineerSubApprovedApplications from './components/Engineer/EngineerSubApprovedApplications';
import EngineerSocietyApprovedApplications from './components/Engineer/EngineerSocietyApprovedApplications';
import EngineerWorkReportMenu from './components/Engineer/EngineerWorkReportMenu';
import EngineerSubWorkReportList from './components/Engineer/EngineerSubWorkReportList';
import EngineerSocietyWorkReportList from './components/Engineer/EngineerSocietyWorkReportList';
import EngineerDocumentDetails from './components/Engineer/EngineerDocumentDetails';
import EngineerEngineerDocuments from './components/Engineer/EngineerEngineerDocuments';
import EngineerWorkAllocation from './components/Engineer/EngineerWorkAllocation';

// Incharge Components
import MainInchargeDashboard from './components/Incharge/MainInchargeDashboard';
import MainviewSubheForm from './components/Incharge/MainviewSubheForm';
import MainviewOldSubheForm from './components/Incharge/MainviewOldSubheForm';
import MainviewSocietyForm from './components/Incharge/MainviewSocietyForm';
import MainviewOldSocietyForm from './components/Incharge/MainviewOldSocietyForm';
import DrawLotteryList from './components/Incharge/DrawLotteryList';
import SocDrawLotteryList from './components/Incharge/SocDrawLotteryList';
import MainviewApplicationForm from './components/Incharge/MainviewApplicationForm';
import MainviewOpenForm from './components/Incharge/MainviewOpenForm';
import GenerateCertificate from './components/Incharge/GenerateCertificate';
import ViewGenerateCertificate from './components/Incharge/ViewGenerateCertificate';
import ShowSubeChallan from './components/Incharge/ShowSubeChallan';
import ShowSocChallan from './components/Incharge/ShowSocChallan';
import SubeShifarasList from './components/Incharge/SubeShifarasList';
import SocShifarasList from './components/Incharge/SocShifarasList';
import UpdateLEStatus from './components/Incharge/UpdateLEStatus';
import LEGeneCertificate from './components/Incharge/LEGeneCertificate';
import LEViewCertificate from './components/Incharge/LEViewCertificate';
import SubeViewPassbook from './components/Incharge/SubeViewPassbook';
import SocViewPassbook from './components/Incharge/SocViewPassbook';
import ViewSubheQuery from './components/Incharge/ViewSubheQuery';
import ViewCompSubheQuery from './components/Incharge/ViewCompSubheQuery';
import ViewSocietyQuery from './components/Incharge/ViewSocietyQuery';
import UploadDDRPatrak from './components/Incharge/UploadDDRPatrak';
import ViewDDRPatrak from './components/Incharge/ViewDDRPatrak';
import MainNewSubheStatus from './components/Incharge/MainNewSubheStatus';
import ScrollToTop from './components/ScrollToTop';

// Admin Components
import AddCeoLayout from './components/Admin/AddCeoLayout';
import AdminDashboard from './components/Admin/Dashboard';
import AdminDocumentVerification from './components/Admin/Documentvarification';
import AdminEngineerRegistrations from './components/Admin/EngineerRegistrations';
import AdminLotteryEngineer from './components/Admin/Lotteryengineer';
import AdminSocietyRegistrations from './components/Admin/SocietyRegistrations';
import AdminSocietyEngineer from './components/Admin/Societyengineer';
import AdminSubenew from './components/Admin/addceoSubenew';
import AdminEngineerLotteryList from './components/Admin/addceoEngineerLotteryList';
import AdminSocnew from './components/Admin/AddceoSocnew';
import AdminSocietyLotteryList from './components/Admin/AddceoSocietyLotteryList';
import AdminDrawLotteryList from './components/Admin/AddceoDrawLotteryList';
import AdminSocDrawLotteryList from './components/Admin/AddceoSocDrawLotteryList';
import AdminSubeShifarasPatra from './components/Admin/AddceosubeShifarasPatra';
import AdminSocWorkOrder from './components/Admin/AddceoSocWorkOrder';
import AdminSubeWorkOrder from './components/Admin/AddceoSubeWorkOrder';
import AdminSubeKamwatap from './components/Admin/AddceoSubeKamwatap';
import AdminSocKamwatap from './components/Admin/AddceoSocKamwatap';
import AdminSubeShifarasList from './components/Admin/AddceoSubeShifarasList';
import AdminSubePaymentList from './components/Admin/AddceoSubePaymentList';
import AdminSocPaymentList from './components/Admin/AddceoSocPaymentList';
import AdminSubePaymentDetailsList from './components/Admin/AddceoSubePaymentDetailsList';
import AdminSocPaymentDetailsList from './components/Admin/AddceoSocPaymentDetailsList';
import AdminUpdate from './components/Admin/Addceoupdate';

// CEO Components
import CeoLayout from './components/CEO/CeoLayout';
import CEODashboard from './components/CEO/CeoDashboard';
import CEODocumentVerification from './components/CEO/Ceoupdate';
import CEOEngineerRegistrations from './components/CEO/CeoSubenew';
import CEOLotteryEngineer from './components/CEO/CeoEngineerLotteryList';
import CEOSocietyRegistrations from './components/CEO/CeoSocnew';
import CEOSocietyEngineer from './components/CEO/CeoSocietyLotteryList';
import CeoSocTipaniList from './components/CEO/CeoSocTipaniList';
import CeoSubeTipaniList from './components/CEO/CeoSubeTipaniList';
import Ceoreportdatewiseinterstedworkreport from './components/CEO/CeoSubeDateWiseIntersted';
import Ceoreportinterestedworkreport from './components/CEO/CeoSubeInterstedWorksList';
import Ceoreportmajurdatewise from './components/CEO/CeoSocDateWiseIntersted';
import Ceoreportmajurinterestedwork from './components/CEO/CeoSocInterstedWorksList';
import Ceoreportmajurlotteryyadi from './components/CEO/CeoSocDrawLotteryList';
import CeosocietyShifarasPatra from './components/CEO/CeosocietyShifarasPatra';
import CeosubeShifarasPatra from './components/CEO/CeosubeShifarasPatra';
import CeoDrawLotteryList from './components/CEO/CeoDrawLotteryList';
import CeoRegistrationChallanList from './components/CEO/CeoRegistrationChallanList';
import CeoShowSubeChallan from './components/CEO/CeoShowSubeChallan';
import CeoSubeWorkOrder from './components/CEO/CeoSubeWorkOrder';
import CeoSocWorkOrder from './components/CEO/CeoSocWorkOrder';
import CeoSubeKamwatap from './components/CEO/CeoSubeKamwatap';
import CeoSocKamwatap from './components/CEO/CeoSocKamwatap';
import CeoSubeShifarasList from './components/CEO/CeoSubeShifarasList';
import CeoSocShifarasList from './components/CEO/CeoSocShifarasList';
import CeoSubePaymentList from './components/CEO/CeoSubePaymentList';
import CeoSocPaymentList from './components/CEO/CeoSocPaymentList';
import CeoWorkAllocation from './components/CEO/CeoWorkAllocation';
import CeoEngineerList from './components/CEO/CeoEngineerList';
import CeoSocietyList from './components/CEO/CeoSocietyList';
import CeoEngineerDocuments from './components/CEO/CeoEngineerDocuments';
import CeoSocietyDocuments from './components/CEO/CeoSocietyDocuments';
import Ceosubhelotteryyadi from './components/CEO/CeosubeDrawLotteryList';
import Worklistmajurchallan from './components/CEO/CeoRegistrationChallanList';
import Worklistsubhechallan from './components/CEO/CeoShowSubeChallan';

// Accountant Components
import AccountantLayout from './components/Accountant/AccountantLayout';
import AccountantDashboard from './components/Accountant/AccountantDashboard';
import AccountantEngineerList from './components/Accountant/AccountantEngineerList';
import AccountantSocietyList from './components/Accountant/AccountantSocietyList';
import AccountantEngineerLotteryList from './components/Accountant/AccountantEngineerLotteryList';
import AccountantSocietyLotteryList from './components/Accountant/AccountantSocietyLotteryList';
import AccountantRegistrationChallanList from './components/Accountant/AccountantRegistrationChallanList';
import AccountantFeeChallanList from './components/Accountant/AccountantFeeChallanList';
import AccountantWorkAllocation from './components/Accountant/AccountantWorkAllocation';
import AccountantSubenew from './components/Accountant/AccountantSubenew';
import AcountantSocnew from './components/Accountant/AcountantSocnew';
import AccountantShowSubeChallan from './components/Accountant/AccountantShowSubeChallan';
import Accountantupdate from './components/Accountant/Accountantupdate';
import AccountantSubeInterstedWorksList from './components/Accountant/AccountantSubeInterstedWorksList';
import AccountantSubeDateWiseIntersted from './components/Accountant/AccountantSubeDateWiseIntersted';
import AccountantSocInterstedWorksList from './components/Accountant/AccountantSocInterstedWorksList';
import AccountantSocDateWiseIntersted from './components/Accountant/AccountantSocDateWiseIntersted';
import AccountantDrawLotteryList from './components/Accountant/AccountantDrawLotteryList';
import AccountantSocDrawLotteryList from './components/Accountant/AccountantSocDrawLotteryList';
import AccountantsubeShifarasPatra from './components/Accountant/AccountantsubeShifarasPatra';
import AccountantsocietyShifarasPatra from './components/Accountant/AccountantsocietyShifarasPatra';
import accountantSubeWorkOrder from './components/Accountant/accountantSubeWorkOrder';
import AccountantSocWorkOrder from './components/Accountant/AccountantSocWorkOrder';
import AccountantSubeKamwatap from './components/Accountant/AccountantSubeKamwatap';
import AccountantSocKamwatap from './components/Accountant/AccountantSocKamwatap';
import AccountantSubeShifarasList from './components/Accountant/AccountantSubeShifarasList';
import AccountantSocPaymentList from './components/Accountant/AccountantSocPaymentList';
import AccountantSubePaymentList from './components/Accountant/AccountantSubePaymentList';
import AccountantSubeFundTransferList from './components/Accountant/AccountantSubeFundTransferList';
import AccountantSubePaymentDetailsList from './components/Accountant/AccountantSubePaymentDetailsList';
import AccountantSocFundTransferList from './components/Accountant/AccountantSocFundTransferList';
import AccountantSocPaymentDetailsList from './components/Accountant/AccountantSocPaymentDetailsList';

// User Components
import ApplicantInformation from './components/users/ApplicantInformation';
import Document from './components/users/Document';
import PassbookUpdateYes from './components/users/PassbookUpdateYes';
import QuerryList from './components/users/QuerryList';
import QuerryUpload from './components/users/QuerryUpload';
import StatusDetails from './components/users/StatusDetails';
import SubheDashboard from './components/users/SubheDashboard';
import SubheDashboard1 from './components/users/SubheDashboard1';
import UploadPlant from './components/users/UploadPlant';
import ChallanDownload from './components/users/ChallanDownload';
import ChallanUpload from './components/users/ChallanUpload';
import ChallanStatus from './components/users/ChallanStatus';
import WorkList from './components/users/WorkList';
import WorkSelectionChallan from './components/users/WorkSelectionChallan';
import KaryarambhAdesh from './components/users/KaryarambhAdesh';
import SelectionLetter from './components/users/SelectionLetter';

// ZP Head Components
import ZpHeadLayout from './components/zphead/ZpHeadLayout';
import ZpHeadDashboard from './components/zphead/ZpHeadDashboard';
import ZpHeadEngineers from './components/zphead/ZpHeadEngineers';
import ZpHeadEngineerDetails from './components/zphead/ZpHeadEngineerDetails';
import ZpHeadEngineerDocuments from './components/zphead/ZpHeadEngineerDocuments';
import ZpHeadSocieties from './components/zphead/ZpHeadSocieties';
import ZpHeadSocietyDetails from './components/zphead/ZpHeadSocietyDetails';
import ZpHeadWorkInfo from './components/zphead/ZpHeadWorkInfo';
import ZpHeadWorkList from './components/zphead/ZpHeadWorkList';
import ZpHeadWorkDetails from './components/zphead/ZpHeadWorkDetails';
import ZpHeadTransferWorkList from './components/zphead/ZpHeadTransferWorkList';
import ZpHeadSocietyTransferWorkList from './components/zphead/ZpHeadSocietyTransferWorkList';
import ZpHeadOpenTransferWorkList from './components/zphead/ZpHeadOpenTransferWorkList';
import ZpHeadGramPanchayatWorkList from './components/zphead/ZpHeadGramPanchayatWorkList';
import ZpHeadEngineerChallanList from './components/zphead/ZpHeadEngineerChallanList';
import ZpHeadSocietyChallanList from './components/zphead/ZpHeadSocietyChallanList';
import ZpHeadReports from './components/zphead/ZpHeadReports';

import ZpHeadRegistrationMenu from './components/zphead/ZpHeadRegistrationMenu';
import ZpHeadInterestedWorkList from './components/zphead/ZpHeadInterestedWorkList';
import ZpHeadInterestedWorkByDate from './components/zphead/ZpHeadInterestedWorkByDate';
import ZpHeadLotteryList from './components/zphead/ZpHeadLotteryList';
import ZpHeadRecommendationLetter from './components/zphead/ZpHeadRecommendationLetter';
import ZpHeadNoteList from './components/zphead/ZpHeadNoteList';
import ZpHeadWorkOrderList from './components/zphead/ZpHeadWorkOrderList';
import ZpHeadWorkOrderView from './components/zphead/ZpHeadWorkOrderView';
import ZpHeadLotteryAllocationReport from './components/zphead/ZpHeadLotteryAllocationReport';
import ZpHeadRecommendationList from './components/zphead/ZpHeadRecommendationList';
import ZpHeadInterestedWorkDetail from './components/zphead/ZpHeadInterestedWorkDetail';
import ZpHeadEngineerMenu from './components/zphead/ZpHeadEngineerMenu';
import ZpHeadSocietyMenu from './components/zphead/ZpHeadSocietyMenu';
import ZpHeadWorkMenu from './components/zphead/ZpHeadWorkMenu';

// Audit Components
import AuditLayout from './components/Audit/AuditLayout';
import AuditDashboard from './components/Audit/AuditDashboard';
import AuditEngineers from './components/Audit/AuditEngineers';
import AuditEngineerDetails from './components/Audit/AuditEngineerDetails';
import AuditEngineerDocuments from './components/Audit/AuditEngineerDocuments';
import AuditSocieties from './components/Audit/AuditSocieties';
import AuditSocietyDetails from './components/Audit/AuditSocietyDetails';
import AuditWorkInfo from './components/Audit/AuditWorkInfo';
import AuditWorkList from './components/Audit/AuditWorkList';
import AuditWorkDetails from './components/Audit/AuditWorkDetails';
import AuditTransferWorkList from './components/Audit/AuditTransferWorkList';
import AuditSocietyTransferWorkList from './components/Audit/AuditSocietyTransferWorkList';
import AuditOpenTransferWorkList from './components/Audit/AuditOpenTransferWorkList';
import AuditGramPanchayatWorkList from './components/Audit/AuditGramPanchayatWorkList';
import AuditEngineerChallanList from './components/Audit/AuditEngineerChallanList';
import AuditSocietyChallanList from './components/Audit/AuditSocietyChallanList';
import AuditReports from './components/Audit/AuditReports';
import AuditRegistrationMenu from './components/Audit/AuditRegistrationMenu';
import AuditEngineerMenu from './components/Audit/AuditEngineerMenu';
import AuditSocietyMenu from './components/Audit/AuditSocietyMenu';
import AuditInterestedWorkList from './components/Audit/AuditInterestedWorkList';
import AuditInterestedWorkByDate from './components/Audit/AuditInterestedWorkByDate';
import AuditInterestedWorkDetail from './components/Audit/AuditInterestedWorkDetail';
import AuditLotteryList from './components/Audit/AuditLotteryList';
import AuditRecommendationLetter from './components/Audit/AuditRecommendationLetter';
import AuditNoteList from './components/Audit/AuditNoteList';
import AuditWorkOrderList from './components/Audit/AuditWorkOrderList';
import AuditUpdateWorkOrder from './components/Audit/AuditUpdateWorkOrder';
import AuditLotteryAllocationReport from './components/Audit/AuditLotteryAllocationReport';
import AuditRecommendationList from './components/Audit/AuditRecommendationList';
import AuditChallanDetails from './components/Audit/AuditChallanDetails';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="App">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/incharge-dashboard" element={<MainInchargeDashboard />} />
          <Route path="/main-incharge-dashboard" element={<MainInchargeDashboard />} />
          <Route path="/engineer-dashboard" element={<EngineerDashboard />} />
          <Route path="/engineer/all-users" element={<EngineerAllUsers />} />
          <Route path="/engineer/work-names" element={<EngineerWorkInfo />} />
          <Route path="/engineer/work-names-list" element={<EngineerWorkNamesMenu />} />
          <Route path="/engineer/work-names-add" element={<EngineerAddWork />} />
          <Route path="/engineer/work-names/edit/:category/:id" element={<EngineerAddWork />} />
          <Route path="/engineer/work-names/details/:category/:id" element={<EngineerWorkDetails />} />
          <Route path="/engineer/work-names-view" element={<EngineerWorkNames />} />
          <Route path="/engineer/lottery-completed-works" element={<EngineerLotteryCompletedWorkList />} />
          <Route path="/engineer/above-10lc-works" element={<EngineerAbove10LCWorks />} />
          <Route path="/engineer/add-bulk-work" element={<EngineerAddBulkWork />} />
          <Route path="/engineer/work-reports-menu" element={<EngineerWorkReportsMenu />} />
          <Route path="/engineer/sume-transfer-work-list" element={<EngineerSumeTransferWorkList />} />
          <Route path="/engineer/society-transfer-work-list" element={<EngineerSocietyTransferWorkList />} />
          <Route path="/engineer/other-transfer-works" element={<EngineerOtherTransferWorks />} />
          <Route path="/engineer/tender-works-menu" element={<EngineerTenderWorksMenu />} />
          <Route path="/engineer/tender-work-list" element={<EngineerTenderWorkList />} />
          <Route path="/engineer/approved-works" element={<EngineerApprovedWorks />} />
          <Route path="/engineer/engineers" element={<EngineerEngineerList />} />
          <Route path="/engineer/engineers/old" element={<EngineerOldEngineerList />} />
          <Route path="/engineer/engineers/details/:id" element={<EngineerEngineerDetails />} />
          <Route path="/engineer/societies" element={<EngineerSocietyList />} />
          <Route path="/engineer/society-menu" element={<EngineerSocietyMenu />} />
          <Route path="/engineer/extend-limit" element={<EngineerExtendLimit />} />
          <Route path="/engineer/extend-limit/edit/:id" element={<EngineerExtendLimitEdit />} />
          <Route path="/engineer/work-passbook-menu" element={<EngineerWorkPassbookMenu />} />
          <Route path="/engineer/subhe-work-list" element={<EngineerSubheWorkList />} />
          <Route path="/engineer/society-work-list" element={<EngineerSocietyWorkList />} />
          <Route path="/engineer/society-work-detail/:id" element={<EngineerSocietyWorkDetail />} />
          <Route path="/engineer/form-65-menu" element={<EngineerForm65Menu />} />
          <Route path="/engineer/subhe-form-65" element={<EngineerSubheForm65 />} />
          <Route path="/engineer/society-form-65" element={<EngineerSocietyForm65 />} />
          <Route path="/engineer/reports-menu" element={<EngineerReportsMenu />} />
          <Route path="/engineer/subhe-certificates" element={<EngineerSubheCertificates />} />
          <Route path="/engineer/subhe-interested-works-menu" element={<EngineerSubheInterestedWorksMenu />} />
          <Route path="/engineer/subhe-interested-works-list" element={<EngineerSubheInterestedWorksList />} />
          <Route path="/engineer/society-interested-works-menu" element={<EngineerSocietyInterestedWorksMenu />} />
          <Route path="/engineer/society-interested-works-list" element={<EngineerSocietyInterestedWorksList />} />
          <Route path="/engineer/society-interested-works-by-date" element={<EngineerSocietyInterestedWorksByDate />} />
          <Route path="/engineer/society-interested-works-detail/:id" element={<EngineerSocietyInterestedWorksDetail />} />
          <Route path="/engineer/inter-governance-menu" element={<EngineerInterGovernanceMenu />} />
          <Route path="/engineer/inter-governance-works-list" element={<EngineerInterGovernanceWorksList />} />
          <Route path="/engineer/inter-governance-works-by-date" element={<EngineerInterGovernanceWorksByDate />} />
          <Route path="/engineer/lottery-reports-menu" element={<EngineerLotteryReportsMenu />} />
          <Route path="/engineer/total-work-distribution-menu" element={<EngineerTotalWorkDistributionMenu />} />
          <Route path="/engineer/sub-works-distribution-list" element={<EngineerSubWorksDistributionList />} />
          <Route path="/engineer/society-works-distribution-list" element={<EngineerSocietyWorksDistributionList />} />
          <Route path="/engineer/lottery-work-distribution-menu" element={<EngineerLotteryWorkDistributionMenu />} />
          <Route path="/engineer/lottery-sub-works-distribution-list" element={<EngineerLotterySubWorksDistributionList />} />
          <Route path="/engineer/lottery-society-works-distribution-list" element={<EngineerLotterySocietyWorksDistributionList />} />
          <Route path="/engineer/approved-records-menu" element={<EngineerApprovedRecordsMenu />} />
          <Route path="/engineer/sub-approved-applications" element={<EngineerSubApprovedApplications />} />
          <Route path="/engineer/society-approved-applications" element={<EngineerSocietyApprovedApplications />} />
          <Route path="/engineer/work-report-menu" element={<EngineerWorkReportMenu />} />
          <Route path="/engineer/sub-work-report-list" element={<EngineerSubWorkReportList />} />
          <Route path="/engineer/society-work-report-list" element={<EngineerSocietyWorkReportList />} />
          <Route path="/engineer/subhe-lottery-list" element={<EngineerSubheLotteryList />} />
          <Route path="/engineer/society-lottery-list" element={<EngineerSocietyLotteryList />} />
          <Route path="/engineer/society-lottery-list-report" element={<EngineerSocietyLotteryListReport />} />
          <Route path="/engineer/district-lottery-list-report" element={<EngineerDistrictLotteryListReport />} />
          <Route path="/engineer/subhe-interested-works-by-date" element={<EngineerSubheInterestedWorksByDate />} />
          <Route path="/engineer/subhe-interested-works-detail/:id" element={<EngineerSubheInterestedWorksDetail />} />
          <Route path="/engineer/subhe-generate-lottery" element={<EngineerSubheGenerateLottery />} />
          <Route path="/engineer/subhe-work-detail/:id" element={<EngineerSubheWorkDetail />} />
          <Route path="/engineer/societies/details/:id" element={<EngineerSocietyDetails />} />
          <Route path="/engineer/society-lottery" element={<EngineerSocietyLotteryList />} />
          <Route path="/engineer/engineer-lottery" element={<EngineerEngineerLotteryList />} />
          <Route path="/engineer/engineers/documents/:id" element={<EngineerEngineerDocuments />} />
          <Route path="/engineer/document-details" element={<EngineerDocumentDetails />} />
          <Route path="/engineer/ddr-certificate" element={<EngineerDDRCertificate />} />
          <Route path="/engineer/generate-certificate" element={<EngineerGenerateCertificate />} />
          <Route path="/engineer/work-allocation" element={<EngineerWorkAllocation />} />
          
          {/* Admin Routes (Grouped under AddCeoLayout for consistent Sidebar) */}
          <Route element={<AddCeoLayout />}>
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/admin/document-verification" element={<AdminDocumentVerification />} />
            <Route path="/admin/engineer-registrations" element={<AdminEngineerRegistrations />} />
            <Route path="/admin/engineer-lottery" element={<AdminLotteryEngineer />} />
            <Route path="/admin/society-registrations" element={<AdminSocietyRegistrations />} />
            <Route path="/admin/society-lottery" element={<AdminSocietyEngineer />} />
            
            {/* Added missing Admin routes mapping to Sidebar */}
            <Route path="/admin/subhe-new-list" element={<AdminSubenew />} />
            <Route path="/admin/engineer-lottery-list" element={<AdminEngineerLotteryList />} />
            <Route path="/admin/society-new-list" element={<AdminSocnew />} />
            <Route path="/admin/society-lottery-list" element={<AdminSocietyLotteryList />} />
            
            {/* CEO compatibility aliases or direct mappings */}
            <Route path="/ceo/worklist-subhe-challan" element={<AdminSubenew />} />
            <Route path="/ceo/worklist-majur-challan" element={<AdminSocnew />} />
            <Route path="/ceo/interested-work-list" element={<AdminSubeKamwatap />} />
            <Route path="/ceo/datewise-interested-work-list" element={<AdminSubeKamwatap />} />
            <Route path="/ceo/majur-interested-work-list" element={<AdminSocKamwatap />} />
            <Route path="/ceo/majur-datewise-interested-work-list" element={<AdminSocKamwatap />} />
            
            <Route path="/addceo/draw-lottery-list" element={<AdminDrawLotteryList />} />
            <Route path="/addceo/society-draw-lottery-list" element={<AdminSocDrawLotteryList />} />
            <Route path="/addceo/subhe-shifaras-patra" element={<AdminSubeShifarasPatra />} />
            <Route path="/addceo/society-shifaras-patra" element={<AdminSubeShifarasPatra />} />
            <Route path="/addceo/subhe-work-order" element={<AdminSubeWorkOrder />} />
            <Route path="/addceo/society-work-order" element={<AdminSocWorkOrder />} />
            <Route path="/addceo/subhe-kamwatap" element={<AdminSubeKamwatap />} />
            <Route path="/addceo/society-kamwatap" element={<AdminSocKamwatap />} />
            <Route path="/addceo/subhe-shifaras-list" element={<AdminSubeShifarasList />} />
            <Route path="/addceo/subhe-payment-list" element={<AdminSubePaymentList />} />
            <Route path="/addceo/society-payment-list" element={<AdminSocPaymentList />} />
            <Route path="/addceo/limit-expand-status" element={<AdminUpdate />} />
          </Route>

          {/* CEO Routes (Grouped under CeoLayout for consistent Sidebar) */}
          <Route element={<CeoLayout />}>
            <Route path="/ceo-dashboard" element={<CEODashboard />} />
            <Route path="/ceo/document-verification" element={<CEODocumentVerification />} />
            <Route path="/ceo/engineer-registrations" element={<CEOEngineerRegistrations />} />
            <Route path="/ceo/lottery-engineers" element={<CEOLotteryEngineer />} />
            <Route path="/ceo/society-registrations" element={<CEOSocietyRegistrations />} />
            <Route path="/ceo/society-engineers" element={<CEOSocietyEngineer />} />
            
            {/* Sidebar Mapping */}
            <Route path="/ceo/verify-documents" element={<AdminDocumentVerification />} />
            <Route path="/ceo/subhe-new-list" element={<CEOEngineerRegistrations />} />
            <Route path="/ceo/engineer-lottery" element={<CEOLotteryEngineer />} />
            <Route path="/ceo/society-new-list" element={<CEOSocietyRegistrations />} />
            <Route path="/ceo/society-lottery" element={<CEOSocietyEngineer />} />
            
            <Route path="/ceo/worklist-subhe-challan" element={<CeoShowSubeChallan />} />
            <Route path="/ceo/worklist-majur-challan" element={<CeoRegistrationChallanList />} />
            
            <Route path="/ceo/interested-work-list" element={<Ceoreportinterestedworkreport />} />
            <Route path="/ceo/datewise-interested-work-list" element={<Ceoreportdatewiseinterstedworkreport />} />
            <Route path="/ceo/majur-interested-work-list" element={<Ceoreportmajurinterestedwork />} />
            <Route path="/ceo/majur-datewise-interested-work-list" element={<Ceoreportmajurdatewise />} />
            
            <Route path="/ceo/draw-lottery-list" element={<CeoDrawLotteryList />} />
            <Route path="/ceo/society-draw-lottery-list" element={<Ceoreportmajurlotteryyadi />} />
            <Route path="/ceo/subhe-shifaras-patra" element={<CeosubeShifarasPatra />} />
            <Route path="/ceo/majur-shifaras-patra" element={<CeosocietyShifarasPatra />} />
            
            <Route path="/ceo/work-order" element={<CeoSubeWorkOrder />} />
            <Route path="/ceo/society-work-order" element={<CeoSocWorkOrder />} />
            <Route path="/ceo/subhe-kamwatapreport" element={<CeoSubeKamwatap />} />
            <Route path="/ceo/society-kamwatapreport" element={<CeoSocKamwatap />} />
            
            <Route path="/ceo/subhe-shifaras-list" element={<CeoSubeShifarasList />} />
            <Route path="/ceo/majur-shifaras-list" element={<CeoSocShifarasList />} />
            <Route path="/ceo/payment-history" element={<CeoSubePaymentList />} />
            <Route path="/ceo/society-payment-history" element={<CeoSocPaymentList />} />
            
            <Route path="/ceo/work-allocation" element={<CeoWorkAllocation />} />
            <Route path="/ceo/engineers" element={<CeoEngineerList />} />
            <Route path="/ceo/societies" element={<CeoSocietyList />} />
            
            <Route path="/ceo/subhe-tipani-yadi" element={<CeoSubeTipaniList />} />
            <Route path="/ceo/majur-tipani-yadi" element={<CeoSocTipaniList />} />
          </Route>

          <Route path="/engineer-registration" element={<EngineerRegistration />} />
          <Route path="/society-registration" element={<SocietyRegistration />} />
          <Route path="/engineer-lottery-registration" element={<EngineerLotteryRegistration />} />
          <Route path="/society-lottery-registration" element={<SocietyLotteryRegistration />} />
          <Route path="/open-application" element={<OpenApplication />} />
          <Route path="/document-list" element={<DocumentList />} />
          <Route path="/society-document-list" element={<SocietyDocumentList />} />
          
          {/* Incharge Routes */}
          <Route path="/main-view-subhe-form" element={<MainviewSubheForm />} />
          <Route path="/main-view-old-subhe-form" element={<MainviewOldSubheForm />} />
          <Route path="/main-view-society-form" element={<MainviewSocietyForm />} />
          <Route path="/main-view-old-society-form" element={<MainviewOldSocietyForm />} />
          <Route path="/main-upload-ddr-patrak" element={<UploadDDRPatrak />} />
          <Route path="/main-view-ddr-patrak" element={<ViewDDRPatrak />} />
          <Route path="/main-view-open-form" element={<MainviewOpenForm />} />
          <Route path="/main-generate-certificate" element={<GenerateCertificate />} />
          <Route path="/main-view-generate-certificate" element={<ViewGenerateCertificate />} />
          <Route path="/main-show-sube-challan" element={<ShowSubeChallan />} />
          <Route path="/main-show-soc-challan" element={<ShowSocChallan />} />
          <Route path="/main-draw-lottery-list" element={<DrawLotteryList />} />
          <Route path="/main-soc-draw-lottery-list" element={<SocDrawLotteryList />} />
          <Route path="/main-sube-shifaras-list" element={<SubeShifarasList />} />
          <Route path="/main-soc-shifaras-list" element={<SocShifarasList />} />
          <Route path="/main-update-le-status" element={<UpdateLEStatus />} />
          <Route path="/main-le-generate-certificate" element={<LEGeneCertificate />} />
          <Route path="/main-le-view-certificate" element={<LEViewCertificate />} />
          <Route path="/main-sube-view-passbook" element={<SubeViewPassbook />} />
          <Route path="/main-soc-view-passbook" element={<SocViewPassbook />} />
          <Route path="/main-sube-pending-query" element={<ViewSubheQuery />} />
          <Route path="/main-sube-comp-query" element={<ViewCompSubheQuery />} />
          <Route path="/main-soc-pending-query" element={<ViewSocietyQuery />} />
          <Route path="/main-view-application-form" element={<MainviewApplicationForm />} />
          <Route path="/main-new-subhe-status" element={<MainNewSubheStatus />} />

          {/* Accountant Routes (Grouped under AccountantLayout for consistent Sidebar) */}
          <Route element={<AccountantLayout />}>
            <Route path="/accountant-dashboard" element={<AccountantDashboard />} />
            <Route path="/accountant/engineers" element={<AccountantEngineerList />} />
            <Route path="/accountant/societies" element={<AccountantSocietyList />} />
            <Route path="/accountant/engineer-lottery" element={<AccountantEngineerLotteryList />} />
            <Route path="/accountant/society-lottery" element={<AccountantSocietyLotteryList />} />
            <Route path="/accountant/registration-challans" element={<AccountantRegistrationChallanList />} />
            <Route path="/accountant/fee-challans" element={<AccountantFeeChallanList />} />
            <Route path="/accountant/work-allocation" element={<AccountantWorkAllocation />} />
            <Route path="/accountant/document-details" element={<EngineerDocumentDetails />} />
            
            <Route path="/accountant/subhe-new-list" element={<AccountantSubenew />} />
            <Route path="/accountant/society-new-list" element={<AcountantSocnew />} />
            <Route path="/accountant/show-sube-challan" element={<AccountantShowSubeChallan />} />
            <Route path="/accountant/limit-expand-status" element={<Accountantupdate />} />
            <Route path="/accountant/subhe-interested-worklist" element={<AccountantSubeInterstedWorksList />} />
            <Route path="/accountant/subhe-datewise-interested-worklist" element={<AccountantSubeDateWiseIntersted />} />
            <Route path="/accountant/society-interested-worklist" element={<AccountantSocInterstedWorksList />} />
            <Route path="/accountant/society-datewise-interested-worklist" element={<AccountantSocDateWiseIntersted />} />
            <Route path="/accountant/draw-lottery-list" element={<AccountantDrawLotteryList />} />
            <Route path="/accountant/society-draw-lottery-list" element={<AccountantSocDrawLotteryList />} />
            <Route path="/accountant/subhe-shifaras-patra" element={<AccountantsubeShifarasPatra />} />
            <Route path="/accountant/society-shifaras-patra" element={<AccountantsocietyShifarasPatra />} />
            <Route path="/accountant/subhe-work-order" element={<accountantSubeWorkOrder />} />
            <Route path="/accountant/society-work-order" element={<AccountantSocWorkOrder />} />
            <Route path="/accountant/sube-kamwatap-report" element={<AccountantSubeKamwatap />} />
            <Route path="/accountant/society-kamwatap-report" element={<AccountantSocKamwatap />} />
            <Route path="/accountant/subhe-shifaras-list" element={<AccountantSubeShifarasList />} />
            <Route path="/accountant/society-payment-list" element={<AccountantSocPaymentList />} />
            <Route path="/accountant/subhe-payment-list" element={<AccountantSubePaymentList />} />
            <Route path="/accountant/subhe-fund-transfer-list" element={<AccountantSubeFundTransferList />} />
            <Route path="/accountant/subhe-payment-details" element={<AccountantSubePaymentDetailsList />} />
            <Route path="/accountant/society-fund-transfer-list" element={<AccountantSocFundTransferList />} />
            <Route path="/accountant/society-payment-details" element={<AccountantSocPaymentDetailsList />} />
          </Route>

          {/* User Routes (Nested under SubheDashboard Layout) */}
          <Route path="/subhe-dashboard" element={<SubheDashboard />}>
            <Route index element={<SubheDashboard1 />} />
            <Route path="applicant-information" element={<ApplicantInformation />} />
            <Route path="documents" element={<Document />} />
            <Route path="passbook-update" element={<PassbookUpdateYes />} />
            <Route path="query-list" element={<QuerryList />} />
            <Route path="query-upload" element={<QuerryUpload />} />
            <Route path="status-details" element={<StatusDetails />} />
            <Route path="upload-plant" element={<UploadPlant />} />
          
          <Route path="worklist" element={<WorkList />} />
            <Route path="work-selection-challan" element={<WorkSelectionChallan />} />
             <Route path="work-order" element={<KaryarambhAdesh />} />
              <Route path="selection-letter" element={<SelectionLetter />} />
            {/* Challan Routes */}
            <Route path="challan-download" element={<ChallanDownload />} />
            <Route path="challan-upload" element={<ChallanUpload />} />
            <Route path="challan-status" element={<ChallanStatus />} />
          </Route>

          {/* ZP Head Routes */}
          <Route path="/zp-head" element={<ZpHeadLayout />}>
            <Route index element={<ZpHeadDashboard />} />
            <Route path="dashboard" element={<ZpHeadDashboard />} />
            <Route path="registration-menu" element={<ZpHeadRegistrationMenu />} />
            <Route path="work-menu" element={<ZpHeadWorkMenu />} />
            <Route path="engineers-menu" element={<ZpHeadEngineerMenu />} />
            <Route path="societies-menu" element={<ZpHeadSocietyMenu />} />
            <Route path="engineers/new" element={<ZpHeadEngineers />} />
            <Route path="engineers/old" element={<ZpHeadEngineers />} />
            <Route path="engineers/details/:id" element={<ZpHeadEngineerDetails />} />
            <Route path="engineers/documents/:id" element={<ZpHeadEngineerDocuments />} />
            <Route path="societies/new" element={<ZpHeadSocieties />} />
            <Route path="societies/old" element={<ZpHeadSocieties />} />
            <Route path="societies/details/:id" element={<ZpHeadSocietyDetails />} />
            <Route path="work-info/list" element={<ZpHeadWorkInfo />} />
            <Route path="work-info/new" element={<ZpHeadWorkList />} />
            <Route path="work-info/lottery-completed" element={<ZpHeadWorkList />} />
            <Route path="work-info/edit/:category/:id" element={<ZpHeadWorkInfo />} />
            <Route path="work-info/details/:category/:id" element={<ZpHeadWorkDetails />} />
                       <Route path="reports" element={<ZpHeadReports />} />
            <Route path="reports/engineer-interested" element={<ZpHeadInterestedWorkList />} />
            <Route path="reports/engineer-interested-date" element={<ZpHeadInterestedWorkByDate />} />
            <Route path="reports/society-interested" element={<ZpHeadInterestedWorkList />} />
            <Route path="reports/society-interested-date" element={<ZpHeadInterestedWorkByDate />} />
            <Route path="reports/interested-detail/:id" element={<ZpHeadInterestedWorkDetail />} />
            <Route path="reports/lottery-list" element={<ZpHeadLotteryList />} />
             <Route path="reports/lottery-list-society" element={<ZpHeadLotteryList />} />
             <Route path="reports/recommendation-letter" element={<ZpHeadRecommendationLetter />} />
             <Route path="reports/recommendation-letter-society" element={<ZpHeadRecommendationLetter />} />
             <Route path="reports/work-allocation-note" element={<ZpHeadNoteList />} />
             <Route path="reports/work-allocation-note-society" element={<ZpHeadNoteList />} />
             <Route path="reports/work-order" element={<ZpHeadWorkOrderList />} />
             <Route path="reports/work-order-society" element={<ZpHeadWorkOrderList />} />
              <Route path="reports/work-order-view" element={<ZpHeadWorkOrderView />} />
            <Route path="reports/lottery-allocation-report" element={<ZpHeadLotteryAllocationReport />} />
            <Route path="reports/lottery-allocation-report-society" element={<ZpHeadLotteryAllocationReport />} />
            <Route path="reports/recommendation-list" element={<ZpHeadRecommendationList />} />
            <Route path="reports/recommendation-list-society" element={<ZpHeadRecommendationList />} />
            <Route path="work-reports/engineer-transfer" element={<ZpHeadTransferWorkList />} />
            <Route path="work-reports/society-transfer" element={<ZpHeadSocietyTransferWorkList />} />
            <Route path="work-reports/open-transfer" element={<ZpHeadOpenTransferWorkList />} />
            <Route path="work-reports/gram-panchayat" element={<ZpHeadGramPanchayatWorkList />} />
            
            <Route path="challan-worklist/engineer" element={<ZpHeadEngineerChallanList />} />
            <Route path="challan-worklist/society" element={<ZpHeadSocietyChallanList />} />
          </Route>

          {/* Audit Routes */}
          <Route path="/audit" element={<AuditLayout />}>
            <Route index element={<AuditDashboard />} />
            <Route path="dashboard" element={<AuditDashboard />} />
            <Route path="registration-menu" element={<AuditRegistrationMenu />} />
            <Route path="engineers-menu" element={<AuditEngineerMenu />} />
            <Route path="societies-menu" element={<AuditSocietyMenu />} />
            <Route path="engineers/new" element={<AuditEngineers />} />
            <Route path="engineers/old" element={<AuditEngineers />} />
            <Route path="engineers/details/:id" element={<AuditEngineerDetails />} />
            <Route path="engineers/documents/:id" element={<AuditEngineerDocuments />} />
            <Route path="societies/new" element={<AuditSocieties />} />
            <Route path="societies/old" element={<AuditSocieties />} />
            <Route path="societies/details/:id" element={<AuditSocietyDetails />} />
            <Route path="work-info/list" element={<AuditWorkInfo />} />
            <Route path="work-info/new" element={<AuditWorkList />} />
            <Route path="work-info/lottery-completed" element={<AuditWorkList />} />
            <Route path="work-info/edit/:category/:id" element={<AuditWorkInfo />} />
            <Route path="work-info/details/:category/:id" element={<AuditWorkDetails />} />
            
            <Route path="reports/engineer-interested" element={<AuditInterestedWorkList />} />
            <Route path="reports/engineer-interested-date" element={<AuditInterestedWorkByDate />} />
            <Route path="reports/society-interested" element={<AuditInterestedWorkList />} />
            <Route path="reports/society-interested-date" element={<AuditInterestedWorkByDate />} />
            <Route path="reports/interested-detail/:id" element={<AuditInterestedWorkDetail />} />
            <Route path="reports/lottery-list" element={<AuditLotteryList />} />
            <Route path="reports/lottery-list-society" element={<AuditLotteryList />} />
            <Route path="reports/recommendation-letter" element={<AuditRecommendationLetter />} />
            <Route path="reports/recommendation-letter-society" element={<AuditRecommendationLetter />} />
            <Route path="reports/work-allocation-note" element={<AuditNoteList />} />
            <Route path="reports/work-allocation-note-society" element={<AuditNoteList />} />
            <Route path="reports/work-order" element={<AuditWorkOrderList />} />
            <Route path="reports/work-order-society" element={<AuditWorkOrderList />} />
            <Route path="reports/work-order-view" element={<ZpHeadWorkOrderView />} />
            <Route path="reports/update-work-order" element={<AuditUpdateWorkOrder />} />
            <Route path="reports/lottery-allocation-report" element={<AuditLotteryAllocationReport />} />
            <Route path="reports/lottery-allocation-report-society" element={<AuditLotteryAllocationReport />} />
            <Route path="reports/recommendation-list" element={<AuditRecommendationList />} />
            <Route path="reports/recommendation-list-society" element={<AuditRecommendationList />} />

            <Route path="work-reports/engineer-transfer" element={<AuditTransferWorkList />} />
            <Route path="work-reports/society-transfer" element={<AuditSocietyTransferWorkList />} />
            <Route path="work-reports/open-transfer" element={<AuditOpenTransferWorkList />} />
            <Route path="work-reports/gram-panchayat" element={<AuditGramPanchayatWorkList />} />
            
            <Route path="challan-worklist/engineer" element={<AuditEngineerChallanList />} />
            <Route path="challan-worklist/society" element={<AuditSocietyChallanList />} />
            <Route path="challan-details/:type/:userId/:paymentId/:subType" element={<AuditChallanDetails />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
